import { render, staticRenderFns } from "./ContactInformationConsents.vue?vue&type=template&id=5e418661&scoped=true&"
import script from "./ContactInformationConsents.vue?vue&type=script&lang=ts&"
export * from "./ContactInformationConsents.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformationConsents.vue?vue&type=style&index=0&id=5e418661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e418661",
  null
  
)

export default component.exports